<template>
    <div class="row p-0">
        <div class="container p-0" v-if="total_tours > 0">
            <div class="row p-0">
                <div class="col-12 col-sm-12 col-lg-4 d-flex justify-content-around align-items-start px-5 px-md-3 px-xl-4 mb-0"
                    v-for="(item, index) of tours" :key="index">
                    <div class="card card-tours mb-3 mb-md-4 mb-xl-5" @click="selectTour(item)" v-if="item.index < view_tours">
                        <img class="card-img-top card-image-tours" :src="item.thumbnail" alt="Card image cap" />
                        <div class="card-body pt-3 px-3">
                            <h6 class="card-title card-title-tours" style="text-overflow: ellipsis;">{{ item[`name_${lang}`] }}</h6>
                            <div>
                                <span class="card-price-normal-tours">${{ item.pricing.adult_base }} MXN</span>
                                <span class="card-discount-tours pl-4">-30%</span>
                            </div>
                            <span class="card-price-discount-tours">${{ item.pricing.adult_average }} MXN</span>
                            <div class="div-description-tours">
                                <span class="card-description-tours">{{ item[`description_short_${lang}`] }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 d-flex justify-content-center align-items-center mb-3">
                    <button v-if="show_button" @click="showTours()" class="btn button-list-tour text-white px-5 font-weight-normal">
                        {{ $t('module_tours.button.see_more') }}
                    </button>
                </div>
            </div>
        </div>
        <!-- <div v-else div="col-12 text-center h-100">
            <span class="text-4 text-center">{{ $t('module_tours.not_tour_list') }}</span>
        </div> -->
    </div>
</template>

<script>
const adventures_image = require("~/assets/json/adventures");

import _GlobalHelper from "@/store/helpers/global";
import _VallartaAdventures from '@/store/helpers/tours/vallarta_adventures'
import _ from "lodash";

import Rating from "@/components/Tour/Rating";

import { mapMutations, mapGetters, mapActions } from "vuex";

const dayAbbreviation = ["S", "M", "T", "W", "T", "F", "S"];
const dayList = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const monthList = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
];
const monthLongList = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];

const enDateFormat = {
    formatDisplay(date) {
        return `${dayList[date.getDay()]}, ${monthList[date.getMonth()]} ${date.getDate()}`;
    },
    formatMonth(date) {
        return `${monthLongList[date.getMonth()]} ${date.getFullYear()}`;
    },
    getWeekDayArray(firstDayOfWeek) {
        let beforeArray = [];
        let afterArray = [];
        for (let i = 0; i < dayAbbreviation.length; i++) {
            if (i < firstDayOfWeek) {
                afterArray.push(dayAbbreviation[i]);
            } else {
                beforeArray.push(dayAbbreviation[i]);
            }
        }
        return beforeArray.concat(afterArray);
    },
    getMonthList() {
        return monthList;
    },
};

export default {
    name: "tours-search",
    components: {
        "tour-rating": Rating,
    },
    data() {
        return {
            tours: {},
            total_tours: null,
            tour_simple: {},
            view_tours: 6,
            show_button: true
        };
    },
    computed: {
        ...mapGetters({
            language: _GlobalHelper.getters.language,
        }),
        loading: {
            set(data) {
                this.set_loading(data);
            },
            get() {
                return this.loading;
            },
        },
        lang: {
            set() {

            },
            get() {
                return this.language
            }
        },
    },
    methods: {
        ...mapActions({
            list_tours:_VallartaAdventures.actions.list,
        }),
        ...mapMutations({
            set_loading: _GlobalHelper.mutations.loading,
            setAlertSimple: _GlobalHelper.mutations.setAlertSimple,
        }),

        async consultTours(received_lang) {
            this.message = []
            
            await this.list_tours({
                lang: received_lang,
                brand_id: this.$config.brand_id,
                operative_source: this.$config.operative_source,
            }).then(({success, data, error}) => {
                if(!success && error == undefined) {
                    this.loading = { show: false }
                    this.setAlertSimple({
                        show: true,
                        title: 'Problemas al procesar la informacion',
                        message: 'No ha sido posible guardar el proceso'
                    })
                    return
                }
                if (!success && error.length >= 0) {
                    if(error.length == 0) {
                        this.message.push(`module_tours.alert.error.error_proccess_request`)
                    }

                    error.forEach((key, index) => {
                        if(key.code == 'database_error') {
                            if(key.detail != undefined){
                                this.message.push(`module_tours.alert.error.${key.code}.detail.${key.detail.transaction}`)
                            }
                            else {
                                this.message.push(`module_tours.alert.error.${key.code}.detail.title`)
                            }
                        } 
                        if(key.code != '' && key.code != 'error_proccess_request' && key.code != 'database_error') {
                            this.message.push(`module_tours.alert.error.${key.code}`)
                        }
                    })

                    if(this.message.length == 0) {
                        this.message.push(`module_tours.alert.error.error_proccess_request`)
                    }

                    if(this.message.length > 0){
                        this.setAlertSimple({
                            show: true,
                            title: 'api.title_error',
                            message: this.message
                        })
                        this.loading = { show: false, message: null}
                    }
                    return

                }
                if(success && data != undefined){
                    for( let [index, item] of Object.entries(data.tours)) {
                        let copy_description = JSON.parse(JSON.stringify(item.description))
                        copy_description = copy_description.replaceAll(/(<([^>]+)>)/gi, '')
                        
                        if(received_lang == 'es'){
                            let tour_es = JSON.parse(JSON.stringify(item))
                            tour_es.index = index
                            tour_es.id = item.id,
                            tour_es.images = item.images,
                            tour_es.pricing = item.pricing,
                            tour_es.passengers = {
                                adults: 0,
                                children: 0
                            },
                            tour_es.restriction_age = item.restriction_age
                            tour_es.review = item.review
                            tour_es.thumbnail = item.thumbnail
                            tour_es.name_es = item.name
                            tour_es.description_es = item.description,
                            tour_es.description_short_es = copy_description
                            tour_es.restrictions_es = item.restrictions
                            this.tours[`${item.id}`] = JSON.parse(JSON.stringify(tour_es))
                        }
                        if(received_lang == 'en') {
                            let tour_en = JSON.parse(JSON.stringify(this.tours[`${item.id}`]))
                            tour_en.name_en = item.name
                            tour_en.description_en = item.description,
                            tour_en.description_short_en = copy_description
                            tour_en.restrictions_en = item.restrictions
                            this.tours[`${item.id}`] = JSON.parse(JSON.stringify(tour_en))
                        }
                        
                    }
                    if(this.$storage.getKey("booking_data") == null) {
                        this.$storage.setKey('booking_data', data.booking)
                    }
                }
            })
        },

        selectTour(data) {
            this.$storage.setKey("tour-selected",  data);

            this.$router.push({
                name: "tours-detail",
                params: {
                    name: data.id,
                },
            });
        },
        showTours(){
            this.show_button = false
            this.view_tours = 9
        }
    },
    async created() {
        this.loading = { show: true, message: `<h5>${this.$i18n.t('loading.global')}</h5>`}
        let langs = ['es', 'en']
        for(let ln in langs) {
            await this.consultTours(langs[ln]);
        }
        this.total_tours = Object.entries(this.tours).length
        this.loading = { show: false, message: null}
        
    },
    beforeRouteLeave(to, from, next) { 
        if(['tours-search', 'tours-checkout'].includes(to.name)){
            return
        }
        else {
            if(!['tours-detail'].includes(to.name)) {
                this.$storage.deleteKey('booking_data')
                next()
                return
            }
        }
        next()
        
    }

};
</script>

<style lang="scss">
.card-image-tours {
    height: 7.3rem !important;
}

@media only screen and (min-width:390px){
    .card-image-tours {
        height: 10.3rem !important;
    }
}

@media only screen and (min-width:470px){
    .card-image-tours {
        height: 13.3rem !important;
    }
}

@media only screen and (min-width:500px){
    .card-image-tours {
        height: 15.3rem !important;
    }
}

@media only screen and (min-width:992px){
    .card-image-tours {
        height: 10.3rem !important;
    }
}


.card-tours {
    box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
        rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
}
.card-tours:hover {
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    opacity: 0.7;
}
.card-title-tours {
    font-family: "Roboto Condensed Bold" sans-serif;
    font-weight: 500;
    font-size: 20px !important;
    text-align: left;
    color: #3b3a3a;
    line-height: 26px !important;
    text-transform: uppercase;
    letter-spacing: 0px;
    opacity: 1;
}
.card-price-normal-tours {
    font-family: "Roboto Condensed", normal;
    font-weight: 100;
    font-size: 17px !important;
    color: #767474;
    line-height: 23px !important;
    text-decoration: line-through;
    letter-spacing: 0px;
}
.card-price-discount-tours {
    font-family: "Roboto Condensed", normal;
    font-weight: 100;
    font-size: 17px !important;
    color: #000000;
    line-height: 23px !important;
    letter-spacing: 0px;
}
.div-description-tours {
    width: auto !important;
    height: 80px !important;
    white-space: normal;
    text-overflow: ellipsis;
    overflow: hidden;
}
.card-description-tours {
    font-family: "Roboto Condensed", normal !important;
    font-weight: 100;
    font-size: 20px !important;
    color: #6c6c6c;
    line-height: 26px !important;
    letter-spacing: 0px;
}
.card-discount-tours {
    font-family: "Roboto Condensed", normal;
    //font-family: 'Roboto Condensed';
    font-weight: 100;
    font-size: 17px !important;
    color: #fdba00;
    line-height: 23px !important;
    letter-spacing: 0px;
}
.card-body{
    height: 220px !important;
}
.button-list-tour{
    background-color: #fdba00 !important;
}
</style>